import React, { useState, useEffect } from "react";
import axios from "axios";
import { GiCrossMark } from "react-icons/gi";
import { PiArrowBendRightDownBold } from "react-icons/pi";
import SoccerBg from "../../../Assets/Images/Home/SoccerBg.webp";
import VolleyballBg from "../../../Assets/Images/Home/VolleyballBg.webp";
import CricketBg from "../../../Assets/Images/Home/CricketBg.webp";
import BasketballBg from "../../../Assets/Images/Home/BasketballBg.webp";
import FootballBg from "../../../Assets/Images/Home/FootballBg.webp";
import specialbg from "../../../Assets/Images/Home/specialattraction.webp";
import soccersImg from "../../../Assets/Images/Home/soccersImg.webp";
import volleyballImg from "../../../Assets/Images/Home/volleyballImg.webp";
import cricketImg from "../../../Assets/Images/Home/BasketballImg.webp";
import basketballImg from "../../../Assets/Images/Home/cricketImg.webp";
import footballImg from "../../../Assets/Images/Home/footballImg.webp";
import specialAttractionimg from "../../../Assets/Images/Home/specialAttractionimg.webp";

const AllEventsSection = () => {
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const categoriesResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`
        );

        const eventsResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/upcomingevent/get-all`
        );

        if (categoriesResponse.data.categories) {
          setCategories(categoriesResponse.data.categories);
        }

        if (eventsResponse.data.success) {
          const upcomingEvents = eventsResponse.data.data.filter(
            (event) => event.status !== "complete"
          );
          setEvents(upcomingEvents);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getImageForSportsCategory = (categoryName) => {
    const name = (categoryName || "").toLowerCase();
    if (name.includes("basketball")) return basketballImg;
    if (name.includes("football")) return footballImg;
    if (name.includes("cricket")) return cricketImg;
    if (name.includes("volleyball")) return volleyballImg;
    if (name.includes("soccer")) return soccersImg;
    if (name.includes("special")) return specialAttractionimg;
  };

  const getBackgroundForSportsCategory = (categoryName) => {
    const name = (categoryName || "").toLowerCase();
    if (name.includes("basketball")) return BasketballBg;
    if (name.includes("football")) return FootballBg;
    if (name.includes("cricket")) return CricketBg;
    if (name.includes("volleyball")) return VolleyballBg;
    if (name.includes("soccer")) return SoccerBg;
    if (name.includes("special")) return specialbg;
  };

  const categoriesWithEvents = categories
    .map((category) => {
      const categoryEvents = events.filter(
        (event) => event?.category?._id === category._id
      );
      return {
        ...category,
        events: categoryEvents,
      };
    })
    .sort((a, b) => b.events.length - a.events.length);

  const toggleEvent = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Date TBA";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Date TBA";

      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    } catch (error) {
      return "Date TBA";
    }
  };

  if (loading) {
    return (
      <div className="px-4 md:px-8 lg:px-12 pb-12">
        <h2
          className="font-heading text-xl md:text-3xl font-bold text-center mb-10"
          data-aos="fade-up"
        >
          UPCOMING EVENTS
        </h2>
        <div className="flex flex-col gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="w-full animate-pulse" data-aos="fade-up">
              <div className="w-full rounded-xl h-20 bg-gray-200"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (categories.length === 0) {
    return (
      <div className="px-4 md:px-8 lg:px-12 pb-12">
        <h2
          className="font-heading text-xl md:text-3xl font-bold text-center mb-10"
          data-aos="fade-up"
        >
          UPCOMING EVENTS
        </h2>
        <div className="text-center py-12" data-aos="fade-up">
          <p className="text-gray-500 text-lg">No categories available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 md:px-8 lg:px-12 pb-12">
      <h2
        className="font-heading text-xl md:text-3xl font-bold text-center mb-10"
        data-aos="fade-up"
      >
        UPCOMING EVENTS
      </h2>
      <div className="flex flex-col gap-6">
        {categoriesWithEvents.map((category, idx) => (
          <div
            key={category._id}
            className="w-full"
          >
            <div
              className="w-full rounded-xl overflow-hidden shadow-md flex items-center justify-between px-4 md:px-6 py-4 bg-cover bg-center relative cursor-pointer"
              style={{
                backgroundImage: `url(${getBackgroundForSportsCategory(
                  category.name
                )})`,
              }}
              onClick={() => toggleEvent(idx)}
            >
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="flex items-center gap-3 relative z-10">
                <img
                  src={getImageForSportsCategory(category.name)}
                  alt={category.name}
                  className="w-8 md:w-10 h-auto object-contain"
                />
                <span className="text-white font-semibold text-lg md:text-xl tracking-wide uppercase">
                  {category.name}
                </span>
              </div>
              <div className="flex items-center gap-4 text-white text-xl md:text-2xl relative z-10">
                {openIndex === idx ? (
                  <GiCrossMark className="transition-transform duration-300" />
                ) : (
                  <PiArrowBendRightDownBold className="transition-transform duration-300" />
                )}
              </div>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${
                openIndex === idx
                  ? "max-h-[1000px] opacity-100"
                  : "max-h-0 opacity-0"
              }`}
              // data-aos="fade-down"
            >
              <div className="bg-white rounded-b-xl shadow-md p-6">
                {category.events.length === 0 ? (
                  <div className="text-center py-8" data-aos="fade-up">
                    <p className="text-gray-500 text-base">
                      No events going on for {category.name}
                    </p>
                  </div>
                ) : (
                  <div className="grid md:grid-cols-2 gap-4">
                    {category.events.map((event, eventIdx) => (
                      <div
                        key={event._id}
                        className="flex items-center justify-between border rounded-lg p-3 hover:shadow-md transition"
                      >
                        <div className="space-y-3 tracking-wide">
                          <p className="text-sm text-[#b90c0c]">
                            {formatDate(event.date)}
                          </p>
                          <p className="font-semibold">
                            {event.team1 && event.team2
                              ? `${event.team1} vs ${event.team2}`
                              : event.name || "Event"}
                          </p>
                          {event.description && (
                            <p className="text-sm text-gray-600 font-medium mt-1">
                              {event.description}
                            </p>
                          )}
                        </div>
                        {event.team1 && event.team2 && (
                          <span className="text-red-600 font-bold text-xl">
                            VS
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllEventsSection;